<div class="introTabHolder">
    <div class="introTabInner">
        <app-heading-holder headerTitle="{{headerTitle}}"></app-heading-holder>
    </div>
    <div class="introTabInner">
        <p [innerHTML]="text"></p>
    </div>
</div>